export default __webpack_public_path__ + "empty-catalog-md.7f5e716d.svg";